var map = {
	"./ft_t-1_stitch_blk.png": 182972,
	"./ft_t-1_stitch_blu.png": 399698,
	"./ft_t-1_stitch_cml.png": 204501,
	"./ft_t-1_stitch_crk.png": 11107,
	"./ft_t-1_stitch_grn.png": 453690,
	"./ft_t-1_stitch_lgd.png": 472008,
	"./ft_t-1_stitch_lsl.png": 440140,
	"./ft_t-1_stitch_nvy.png": 614532,
	"./ft_t-1_stitch_orn.png": 343922,
	"./ft_t-1_stitch_pnk.png": 612312,
	"./ft_t-1_stitch_ppl.png": 516149,
	"./ft_t-1_stitch_red.png": 876360,
	"./ft_t-1_stitch_sax.png": 204685,
	"./ft_t-1_stitch_wht.png": 429826,
	"./ft_t-1_stitch_ylw.png": 20939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12592;